import React from 'react'
import './Footer.css'

export default function Footer() {
    return (
        <div className='footerContainer'>
            <hr className='m-0 footer-hr mx-auto' />
            <div className='container'>
                <footer className="apple-footer">
                    <div className="footer-container">
                        <div className="footer-column">
                            <h4 className='mt-4 mb-2'>Shop and Learn</h4>
                            <a href="#">Store</a>
                            <a href="#">Mac</a>
                            <a href="#">iPad</a>
                            <a href="#">iPhone</a>
                            <a href="#">Watch</a>
                            <a href="#">Vision</a>
                            <a href="#">AirPods</a>
                            <a href="#">TV & Home</a>
                            <a href="#">AirTag</a>
                            <a href="#">Accessories</a>
                            <a href="#">Gift Cards</a>

                            <h4 className='mt-4 mb-2'>Apple Wallet</h4>
                            <a href="#">Wallet</a>
                            <a href="#">Apple Card</a>
                            <a href="#">Apple Pay</a>
                            <a href="#">Apple Cash</a>
                        </div>

                        <div className="footer-column">
                            <h4 className='mt-4 mb-2'>Account</h4>
                            <a href="#">Manage Your Apple Account</a>
                            <a href="#">Apple Store Account</a>
                            <a href="#">iCloud.com</a>

                            <h4 className='mt-4 mb-2'>Entertainment</h4>
                            <a href="#">Apple One</a>
                            <a href="#">Apple TV</a>
                            <a href="#">Apple Music</a>
                            <a href="#">Apple Arcade</a>
                            <a href="#">Apple Fitness+</a>
                            <a href="#">Apple News+</a>
                            <a href="#">Apple Podcasts</a>
                            <a href="#">Apple Books</a>
                            <a href="#">App Store</a>
                        </div>

                        <div className="footer-column">
                            <h4 className='mt-4 mb-2'>Apple Store</h4>
                            <a href="#">Find a Store</a>
                            <a href="#">Genius Bar</a>
                            <a href="#">Today at Apple</a>
                            <a href="#">Apple Camp</a>
                            <a href="#">Apple Store App</a>
                            <a href="#">Certified Refurbished</a>
                            <a href="#">Apple Trade In</a>
                            <a href="#">Financing</a>
                            <a href="#">Carrier Deals at Apple</a>
                            <a href="#">Order Status</a>
                            <a href="#">Shopping Help</a>
                        </div>

                        <div className="footer-column">
                            <h4 className='mt-4 mb-2'>For Business</h4>
                            <a href="#">Apple and Business</a>
                            <a href="#">Shop for Business</a>

                            <h4 className='mt-4 mb-2'>For Education</h4>
                            <a href="#">Apple and Education</a>
                            <a href="#">Shop for K-12</a>
                            <a href="#">Shop for College</a>

                            <h4 className='mt-4 mb-2'>For Healthcare</h4>
                            <a href="#">Apple in Healthcare</a>
                            <a href="#">Health on Apple Watch</a>
                            <a href="#">Health Records on iPhone</a>

                            <h4 className='mt-4 mb-2'>For Government</h4>
                            <a href="#">Shop for Government</a>
                            <a href="#">Shop for Veterans and Military</a>
                        </div>

                        <div className="footer-column">
                            <h4 className='mt-4 mb-2'>Apple Values</h4>
                            <a href="#">Accessibility</a>
                            <a href="#">Education</a>
                            <a href="#">Environment</a>
                            <a href="#">Inclusion and Diversity</a>
                            <a href="#">Privacy</a>
                            <a href="#">Racial Equity and Justice</a>
                            <a href="#">Supply Chain</a>

                            <h4 className='mt-4 mb-2'>About Apple</h4>
                            <a href="#">Newsroom</a>
                            <a href="#">Apple Leadership</a>
                            <a href="#">Career Opportunities</a>
                            <a href="#">Investors</a>
                            <a href="#">Ethics & Compliance</a>
                            <a href="#">Events</a>
                            <a href="#">Contact Apple</a>
                        </div>

                    </div>
                </footer>

            </div>
        </div>
    )
}
